import { refusalsByReason, type BulkOutcome } from '@/domain';
import { strings } from '@/shared/strings';
import { Button } from '@/ui/primitives/Button';
import { Modal } from '@/ui/primitives/Modal';
import styles from './BulkResultDialog.module.css';

/**
 * What became of a selection when some of it could not be done. Section 4 of
 * the request of 24 September 2026.
 *
 * Only when something was refused: a selection that went through whole says so
 * in a toast and gets out of the way. The refusals are grouped by what the
 * server said, so twelve cases already archived read as one sentence with twelve
 * numbers under it rather than twelve sentences.
 */
export function BulkResultDialog({
  verb,
  outcomes,
  onClose,
}: {
  /** What was done to the ones that went: "archived", "assigned". */
  verb: string;
  outcomes: readonly BulkOutcome[];
  onClose: () => void;
}) {
  const done = outcomes.filter((outcome) => outcome.ok).length;
  const groups = refusalsByReason(outcomes);

  return (
    <Modal
      title={strings.bulk.resultTitle}
      lead={
        done === 0
          ? strings.bulk.resultNone
          : `${done} ${strings.bulk.resultOf} ${outcomes.length} ${verb}. ${strings.bulk.notDone}:`
      }
      onClose={onClose}
      footer={
        <Button variant="primary" onClick={onClose}>
          {strings.bulk.close}
        </Button>
      }
    >
      <ul className={styles.groups}>
        {groups.map((group) => (
          <li key={group.detail}>
            <p className={styles.detail}>{group.detail}</p>
            <p className={styles.ids}>{group.ids.join(', ')}</p>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
